/** @format */

import { loginEvent, signupEvent, apiError } from "../../utils/GTMDataLayer";
import * as actionTypes from "./../types";
import cookie from "js-cookie";
import Router from "next/router";
// import { logger } from "cbt-sdk";
import { logger } from "@goldenbird1/ui-logger-library";
import { useCookies } from "react-cookie";
import { getCookie } from "../../utils/getcookie";
import { v4 as uuidv4 } from "uuid";

let retryCount = 0;

export const setUserProfileLoading = (isLoading) => {
  return {
    type: actionTypes.GET_USER_PROFILE_LOADING,
    payload: {
      isLoading: isLoading,
    },
  };
};

export const setUserProfile = (userProfile) => {
  return {
    type: actionTypes.GET_USER_PROFILE,
    payload: {
      userProfile: userProfile,
    },
  };
};


const xsrfToken = getCookie('XSRF-TOKEN');
xsrfToken && console.log("testing::cookievalue",xsrfToken)


export const setUserProfileFailed = (error) => {
  return {
    type: actionTypes.GET_USER_PROFILE_FAILED,
    payload: {
      error: error,
    },
  };
};

const setUserProfileData = (data, token, callback = "") => {
  /* read utm source from cookie and update in profile  */
  // const [cookie] = useCookies(["utm_source"]);
  if (data && cookie.get("utm_source")) {
    let cookieVal = JSON.parse(cookie.get("utm_source"));

    data.utm = cookieVal.utm_source.replace(/['"]/g, "");
    data.utmCampaign = cookieVal?.utm_campaign.replace(/['"]/g, "");
    data.utmMedium = cookieVal?.utm_medium.replace(/['"]/g, "");
    data.utmTerm = cookieVal?.utmTerm.replace(/['"]/g, "");
    data.adGroupId = cookieVal?.adGroupId.replace(/['"]/g, "");
    data.keyword = cookieVal?.keyword.replace(/['"]/g, "");
  } else {
    data.utm = "";
  }
  /* ------- */
  let url = process.env.NEXT_PUBLIC_REACT_APP_API_PROFILE_URL + "/profiles/update/my";
  fetch(
    url,
    {
      method: "PATCH",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    }
  )
  .then((res) => {
    if (res.ok) {
      return res.json();
    } else {
      // apiError('setUserProfileData', res.statusText || "Error while sending request.", 'PATCH', 'userProfile');
      throw res;
    }
  })
  .then((res) => {
    callback(res);
  })
  .catch((err) => {
    logger("error", "Error from setUserProfileData api:" + url + ",payload="+ JSON.stringify(data)+ " :  " +err.statusText, process.env.NEXT_PUBLIC_LOGGER_URL);
    // apiError('setUserProfileData', err, 'PATCH', 'userProfile');
    if(err.status === 401){
      Router.push('/signin');
    } else {
      if (retryCount < 3) {
        setUserProfileData(data, token, callback);
      } else {
        console.log(err);
      }
      retryCount++;
    }
  });
};



export const completeUserRegistration =
  (data, token, callback) => async (dispatch) => {
    // console.log('check for buyerId', localStorage.getItem('userid'))
    // let bId = localStorage.getItem('userid') ? localStorage.getItem('userid') : buyerId;
    let cookieValXSRF = cookie.get("XSRF-TOKEN")
    console.log("cookieValXSRF",cookieValXSRF)
    const xsrfToken = getCookie('XSRF-TOKEN');
    console.log('check for xsrfToken', xsrfToken)
    let url =
      process.env.NEXT_PUBLIC_REACT_APP_CONTENT_BFF_URL + "/profile/v1/profiles/my";
    fetch(url, {
      method: "PATCH",
      body: JSON.stringify(data),
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
        "X-XSRF-TOKEN": cookieValXSRF,
        Accept: "*/*",
        "trace-id": uuidv4(),
      },
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          apiError(
            "CompleteUserRegistration",
            res.statusText ||
              "Error while saving user details. Please try again!",
            "PATCH",
            "userProfile"
          );
          throw res;
        }
      })
      .then((res) => {
        callback(res);
        return dispatch(setUserProfile(res));
      })
      .catch((err) => {
        logger(
          "error",
          "Error from completeUserRegistration api:" +
            url +
            ",payload=" +
            JSON.stringify(data) +
            err.statusText,
          process.env.NEXT_PUBLIC_LOGGER_URL
        );
        apiError("CompleteUserRegistration", err, "PATCH", "userProfile");
        if (err.status === 401) {
          Router.push("/signin");
        }
        callback({ error: err });
        console.log(err.message);
      });
  };

/* new user registration api */
export const completeUserRegistrationApi =
  (data, callback) => async (dispatch) => {
    // console.log('check for buyerId', localStorage.getItem('userid'))
    let url =
      process.env.NEXT_PUBLIC_REACT_APP_CONTENT_BFF_URL +
      "/profile/v1/identity/register";
 
    fetch(url, {
      method: "POST",
      body: JSON.stringify(data),
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "trace-id": uuidv4(),
      },
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          apiError(
            "CompleteUserRegistration",
            res.statusText ||
              "Error while saving user details. Please try again!",
            "PATCH",
            "userProfile"
          );
          throw res;
        }
      })
      .then((res) => {
        callback(res);
        // return dispatch(setUserProfile(res));
      })
      .catch((err) => {
        logger(
          "error",
          "Error from completeUserRegistration api:" +
            url +
            ",payload=" +
            JSON.stringify(data) +
            err.statusText +
            ": for buyerId:" +
            buyerId,
          process.env.NEXT_PUBLIC_LOGGER_URL
        );
        apiError(
          "CompleteUserRegistration",
          err.statusText,
          "PATCH",
          "userProfile"
        );
        if (err.status === 401) {
          Router.push("/signin");
        }
        callback({ error: err });
        console.log(err.message);
      });
  };

let retryUserProfile = 0;
export const getUserProfile = (token, callback = "") => {
  let buyerId = localStorage.getItem('userid') ? localStorage.getItem('userid') : null;
  if(token && typeof token === 'string'){
    return (dispatch) => {
      dispatch(setUserProfileLoading(true));
      // let buyerId = buyerId;
      return fetch(
            process.env.NEXT_PUBLIC_REACT_APP_CONTENT_BFF_URL + "/profile/v1/profiles/my",
        {
          method: "GET",
          credentials:"include",
          headers: {
            Authorization: "Bearer " + token,
            'trace-id' : uuidv4()
          },
        }
      )
        .then((res) => {
          if (res.ok) {
            return res.json();
          } else {
            throw res;
          }
        })
        .then((initialResult) => {
          // dispatch(getMeetingCount(result.profileId, token));
          let { profileCreated = false } = initialResult || {};
          if (profileCreated === null || profileCreated === false) {
            signupEvent();
            let data = {};
            fetch(
              "https://ipapi.co/json/?key=JWzTw2TRf981G4oH1uZB5EwoM7iuNetMOB70dIhbnTAaO121To",
              {
                method: "GET",
              }
            )
              .then((response) => response.json())
              .then((result) => {
                let { ip = "", country_name = "" } = result;
                data.ipAddress = ip;
                data.country = country_name;
                setUserProfileData(data, token, (res) => {
                  dispatch(setUserProfileLoading(false));
                  // if(res.profileComplete === true){
                    const profileObj = {
                      "profileId": res.profileId,
                      "profileType": res.profileType,
                      "profileComplete": res.profileComplete,
                      "profileCreated": res.profileCreated,
                      "verificationStatus": res.verificationStatus,
                      "isDropShipBuyer": res.isDropShipBuyer,
                      "kcIdentityId": res.kcIdentityId,
                      "notificationToWhatsUp": res.recieveWhatsappMessage ? JSON.parse(res.recieveWhatsappMessage) : null
                    }
                    localStorage.setItem("userProfile", JSON.stringify(profileObj));
                  // }
                  if(callback){
                    callback(res);
                  }
                  return dispatch(setUserProfile(res));
                });
              })
              .catch((err) => {
                apiError('getipdetails', err, 'GET', 'fetch IP');
                let { ip = "", country_name = "" } = {};
                data.ipAddress = ip;
                data.country = country_name;
                setUserProfileData(data, token, (res) => {
                  dispatch(setUserProfileLoading(false));
                  // if(res.profileComplete === true){
                    const profileObj = {
                      "profileId": res.profileId,
                      "profileType": res.profileType,
                      "profileComplete": res.profileComplete,
                      "profileCreated": res.profileCreated,
                      "verificationStatus": res.verificationStatus,
                      "isDropShipBuyer": res.isDropShipBuyer,
                      "kcIdentityId": res.kcIdentityId,
                      "notificationToWhatsUp": res.recieveWhatsappMessage ? JSON.parse(res.recieveWhatsappMessage) : null
                    }
                    localStorage.setItem("userProfile", JSON.stringify(profileObj));
                  // }
                  if(callback){
                    callback(res);
                  }
                  return dispatch(setUserProfile(res));
                });
              });
          } else {
            dispatch(setUserProfileLoading(false));
            // if(initialResult.profileComplete === true){
              const profileObj = {
                "profileId": initialResult.profileId,
                "profileType": initialResult.profileType,
                "profileComplete": initialResult.profileComplete,
                "profileCreated": initialResult.profileCreated,
                "verificationStatus": initialResult.verificationStatus,
                "isDropShipBuyer": initialResult.isDropShipBuyer,
                "kcIdentityId": initialResult.kcIdentityId,
                "notificationToWhatsUp": initialResult.recieveWhatsappMessage ? initialResult.recieveWhatsappMessage : null
              }
              localStorage.setItem("userProfile", JSON.stringify(profileObj));
            // }
            if(callback){
              callback(initialResult);
            }
            return dispatch(setUserProfile(initialResult));
          }
        })
        .catch((error) => {
          if(error.status === 401){
            Router.push('/signin');
            sessionStorage.removeItem('isSocialSignup');
            localStorage.removeItem('kcTokenSaved');
            sessionStorage.removeItem('kcTokenSaved');
            localStorage.removeItem('longTimeUser');
            localStorage.removeItem('shortTimeUser');
            localStorage.removeItem('kcAccessToken');
            localStorage.removeItem('kcRefreshToken');
            localStorage.removeItem('rValidity');
            localStorage.removeItem('aValidity');
          }
          if(callback){
            callback({error: true});
          }
          logger("error", "Error from getUserProfile api: "+error.statusText+ ': for buyerId:' + buyerId, process.env.NEXT_PUBLIC_LOGGER_URL);
          apiError('getUserProfile', error.statusText, 'GET', 'userProfile');
          console.log("Inside profile error", error, process.env.NODE_ENV);
          dispatch(setUserProfileLoading(false));
          return dispatch(setUserProfileFailed(error));
        });
    };
  } else {
    Router.push('/signin');
  }
};

export const setSellerAgreement = (filename, token) => async (dispatch) => {
  let ip_details = await dispatch(getCurrentIP());
  // console.log(ip_details.ip);
  const xsrfToken = getCookie('XSRF-TOKEN');
  let cookieValXSRF = cookie.get("XSRF-TOKEN")
    console.log("cookieValXSRF",cookieValXSRF)
  let body = {
    agreementAgreed: true,
    agreementSourceIP: (ip_details && ip_details.ip) || null,
    agreementTitle: filename,
  };

fetch(
  process.env.NEXT_PUBLIC_REACT_APP_CONTENT_BFF_URL + "/profile/v1/profiles/my",
  {
    method: "PATCH",
    body: JSON.stringify(body),
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
      "X-XSRF-TOKEN": cookieValXSRF,
      Accept: "*/*",
      "trace-id": uuidv4(),
    },
  }
)
  .then((res) => {
    if (res.ok) {
      return res.json();
    } else {
      apiError(
        "setSellerAgreement",
        res.statusText || "Error while saving user details.",
        "PATCH",
        "userProfile"
      );
      throw res;
    }
  })
  .then((res) => {
    return true;
  })
  .catch((err) => {
    logger(
      "error",
      "Error from setSellerAgreement api:" +
        err.statusText +
        " : " +
        JSON.stringify(body),
      process.env.NEXT_PUBLIC_LOGGER_URL
    );
    apiError("setSellerAgreement", err, "PATCH", "userProfile");
    if (err.status === 401) {
      Router.push("/signin");
    }
    // console.log(err.message);
    // message.error((err.message || err), 5);
    // setErrors(errors.concat(err));
  });
};

export const getCurrentIP = () => async (dispatch) => {
  return await fetch(
    "https://ipapi.co/json/?key=JWzTw2TRf981G4oH1uZB5EwoM7iuNetMOB70dIhbnTAaO121To",
    {
      method: "GET",
    }
  )
    .then((response) => 
      {
        if(response.ok){
          response.json();
        } else {
          throw response;
        }
      })
    .catch((err) => {
      logger("error", "Error from getCurrentIP api:" +err.statusText, process.env.NEXT_PUBLIC_LOGGER_URL);
      apiError('getCurrentIP', err, 'GET', 'userProfile');
      if(err.status === 401){
        Router.push('/signin');
      }
      // console.log("Error ", err);
    });
};

export const getOpenRequest =
  (token, profileId, status) => async (dispatch) => {
    // dispatch(setScheduleRequests(scheduleRequests))
    let url =
      process.env.NEXT_PUBLIC_REACT_APP_API_MEETING_URL +
      "/events/meeting/my?profile_id=" +
      profileId +
      "&status=" +
      status;
    fetch(url, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        Accept: "*/*",
      },
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          apiError('getOpenRequest', res.statusText || "Error in getOpenRequest/meetings api.", 'GET', 'userProfile');
          throw res;
        }
      })
      .then((res) => {
        return dispatch(setOpenRequest(res));
      })
      .catch((err) => {
        logger("error", "Error from getOpenRequest/meetings api:"+url+ " : buyerId => "+profileId + ' : error =>' +err.statusText, process.env.NEXT_PUBLIC_LOGGER_URL);
        apiError('getOpenRequest', err.statusText, 'GET', 'userProfile');
        if(err.status === 401){
          Router.push('/signin');
        }
        // console.log(err.message);
        // message.error((err.message || err), 5);
        // setErrors(errors.concat(err));
      });
  };

export const setOpenRequest = (result) => {
  return {
    type: actionTypes.SET_OPEN_REQUEST,
    payload: {
      openRequest: result,
    },
  };
};

export const setScheduleRequests = (result) => {
  return {
    type: actionTypes.SET_SCHEDULE_REQUESTS,
    payload: {
      scheduleRequest: result,
    },
  };
};

export const getRequestByStatus = (token, profileId, status) => {
  return (dispatch) => {
    let url =
      process.env.NEXT_PUBLIC_REACT_APP_API_MEETING_URL +
      "/events/meeting/my?profile_id=" +
      profileId +
      "&status=" +
      status;
    fetch(url, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
      },
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          apiError('getRequestByStatus', res.statusText || "Error from getRequestByStatus/meetings api.", 'GET', 'userProfile');
          throw res;
        }
      })
      .then((res) => {
        return dispatch(setScheduleRequests(res));
      })
      .catch((err) => {
        logger("error", "Error from getRequestByStatus/meetings api:" +url + " : buyerId =>" +profileId + ': error =>' +err.statusText, process.env.NEXT_PUBLIC_LOGGER_URL);
        apiError('getRequestByStatus', err.statusText, 'GET', 'userProfile');
        if(err.status === 401){
          Router.push('/signin');
        }
        // console.log(err.message);
        // message.error((err.message || err), 5);
        // setErrors(errors.concat(err));
      });
  };
};

export const getMeetingCount = (profileId, token) => {
  return (dispatch) => {
    let url =
      process.env.NEXT_PUBLIC_REACT_APP_API_MEETING_URL +
      "/events/meeting/count?profile_id=" +
      profileId;
    fetch(url, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
      },
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          apiError('getMeetingCount', res.statusText || "Error from getMeetingCount/meetings api.", 'GET', 'userProfile')
          throw res;
        }
      })
      .then((res) => {
        return dispatch(setMeetingCount(res));
        // return dispatch(setScheduleRequests(res));
      })
      .catch((err) => {
        logger("error", "Error from getMeetingCount/meetings api:"+ url + " : buyerId => " +profileId + ': error =>' +err.statusText, process.env.NEXT_PUBLIC_LOGGER_URL);
        apiError('getMeetingCount', err.statusText, 'GET', 'userProfile');
        if(err.status === 401){
          Router.push('/signin');
        }
        // console.log(err.message);
        // message.error((err.message || err), 5);
        // setErrors(errors.concat(err));
      });
  };
};

export const setMeetingCount = (count) => {
  return {
    type: actionTypes.SET_MEETING_COUNT,
    payload: {
      meetingCount: count,
    },
  };
};

export const getAddresses = (profileId, token) => async (dispatch) => {
  // dispatch(setScheduleRequests(scheduleRequests))
  let url =
    process.env.NEXT_PUBLIC_REACT_APP_CONTENT_BFF_URL + "/contact/v1/contact";
  fetch(url, {
    method: "GET",
    headers: {
      Authorization: "Bearer " + token,
      Accept: "*/*",
      "trace-id": uuidv4(),
    },
  })
    .then((res) => {
      if (res.ok) {
        return res.json();
      } else {
        apiError(
          "getAddresses",
          res.statusText || "Error from getAddresses api.",
          "GET",
          "userProfile"
        );
        throw res;
      }
    })
    .then((res) => {
      return dispatch(setMyAddresse(res));
    })
    .catch((err) => {
      logger(
        "error",
        "Error from getAddresses api:" +
          url +
          " : buyerId => " +
          profileId +
          ": error => " +
          err.statusText,
        process.env.NEXT_PUBLIC_LOGGER_URL
      );
      apiError("getAddresses", err.statusText, "GET", "userProfile");
      if (err.status === 401) {
        Router.push("/signin");
      }
      // console.log(err.message);
      // message.error((err.message || err), 5);
      // setErrors(errors.concat(err));
    });
};

export const setMyAddresse = (data) => {
  return {
    type: actionTypes.SET_MY_ADDRESSES,
    payload: {
      addresses: data,
    },
  };
};

export const getBrandNameByCode =
  (codes, token, quoteData, buyerId) => async (dispatch) => {
    let removedExtraCommas = codes?.replace(/,+/g, ",").replace(/^,|,$/g, ""); 
    let url = process.env.NEXT_PUBLIC_REACT_APP_CONTENT_BFF_URL +
      "/profile/v1/seller-home/internal-views?ids=" + removedExtraCommas;
    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
        "trace-id": uuidv4(),
      },
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          apiError(
            "getBrandNameByCode",
            res.statusText || "Oops something went wrong. Please try again!",
            "GET",
            "userProfile"
          );
          throw res;
        }
      })
      .then((res) => {
        return dispatch(setBrandNameByIds(res));
        // getBrandNameByIds()
      })
      .catch((err) => {
        logger(
          "error",
          "Error from getBrandNameByCode api :" +
            url +
            " : buyerId => " +
            buyerId +
            ": error => " +
            err.statusText,
          process.env.NEXT_PUBLIC_LOGGER_URL
        );
        apiError("getBrandNameByCode", err.statusText, "GET", "userProfile");
        if (err.status === 401) {
          Router.push("/signin");
        }
        // message.error(err.message || err, 5);
      });
  };

export const getQuoteByStatus =
  (token, status, currentTab, buyerId) => async (dispatch) => {
    // dispatch(setScheduleRequests(scheduleRequests))
   let url =
     process.env.NEXT_PUBLIC_REACT_APP_CONTENT_BFF_URL +
     "/home/v1/quotes/custom?status=" +
     status +
     "&buyer_id=" +
     buyerId;

    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
        "trace-id": uuidv4(),
      },
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          apiError(
            "getQuoteByStatus",
            res.statusText || "Oops something went wrong. Please try again!",
            "GET",
            "userProfile"
          );
          throw res;
        }
      })
      .then((res) => {
        let sellerCodeList = [];
        if (currentTab != "requested") {
          res.map((e) => {
            if (e.subOrders) {
              e.subOrders.map((sub) => {
                if (!sellerCodeList.includes(sub.sellerCode)) {
                  sellerCodeList.push(sub.sellerCode);
                }
              });
            } else {
              if (!sellerCodeList.includes(e.sellerCode)) {
                sellerCodeList.push(e.sellerCode);
              }
            }
          });
          let codes = sellerCodeList.join();
          dispatch(getBrandNameByCode(codes, token, res, buyerId));
        } else {
          res.map((e) => {
            if (!sellerCodeList.includes(e.sellerCode)) {
              sellerCodeList.push(e.sellerCode);
            }
          });
          let codes = sellerCodeList.join();
          dispatch(getBrandNameByCode(codes, token, res, buyerId));
        }
        return dispatch(setQuoteBYStatus(res));
      })
      .catch((err) => {
        logger(
          "error",
          "Error from getQuoteByStatus api :" +
            url +
            " : buyerId => " +
            buyerId +
            " : error => " +
            err.statusText,
          process.env.NEXT_PUBLIC_LOGGER_URL
        );
        apiError("getQuoteByStatus", err.statusText, "GET", "userProfile");
        if (err.status === 401) {
          Router.push("/signin");
        }
        // message.error(err.message || err, 5);
      });
  };

export const setBrandNameByIds = (data) => {
  return {
    type: actionTypes.SET_BRAND_NAME,
    payload: {
      brandNameList: data,
    },
  };
};

export const setQuoteBYStatus = (data) => {
  return {
    type: actionTypes.SET_QUOTE_BY_STATUS,
    payload: {
      quoteByStatus: data,
    },
  };
};

export const getOrderByOrderId = (token, orderId, buyerId) => async (dispatch) => {
  // dispatch(setScheduleRequests(scheduleRequests))
  let url = process.env.NEXT_PUBLIC_REACT_APP_CONTENT_BFF_URL + "/order-orchestration/v1/orders/composite/" + orderId;

  fetch(
    url,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
        'trace-id':uuidv4()
      },
    }
  )
    .then((res) => {
      if (res.ok) {
        return res.json();
      } else {
        apiError('getOrderByOrderId', res.statusText || "Oops something went wrong. Please try again!", 'GET', 'userProfile');
        throw res;
      }
    })
    .then((res) => {
      let sellerCodeList = [];
      res.subOrders.map((subOrder) => {
        if (!sellerCodeList.includes(subOrder.sellerCode)) {
          sellerCodeList.push(subOrder.sellerCode);
        }
      });
      let codes = sellerCodeList.join();
      dispatch(getBrandNameByCode(codes, token, res, buyerId));
      return dispatch(setOrderByOrderId(res));
    })
    .catch((err) => {
      logger("error", "Error from getOrderByOrderId api :" + url + ' : buyerId => ' +buyerId+ ': error => ' +err, process.env.NEXT_PUBLIC_LOGGER_URL);
      apiError('getOrderByOrderId', err, 'GET', 'userProfile');
      console.log("err ", err);
      let { status = "" } = err;
      if (status === 404) {
        Router.push("/account/profile?invalid_user=true");
      } else if(status === 401){
        Router.push('/signin');
      }
    });
};

export const setOrderByOrderId = (data) => {
  return {
    type: actionTypes.SET_ORDER_BY_ID,
    payload: {
      order: data,
    },
  };
};

export const getOrders = (token, buyerId) => async (dispatch) => {
  // dispatch(setScheduleRequests(scheduleRequests))
  let url =
    process.env.NEXT_PUBLIC_REACT_APP_CONTENT_BFF_URL +
    "/order-orchestration/v1/order";
  fetch(url, {
    method: "GET",
    headers: {
      Authorization: "Bearer " + token,
      Accept: "*/*",
      "trace-id": uuidv4(),
    },
  })
    .then((res) => {
      if (res.ok) {
        return res.json();
      } else {
        apiError(
          "getOrders",
          res.statusText || "Error from getOrders api",
          "GET",
          "userProfile"
        );
        throw res;
      }
    })
    .then((res) => {
      let sellerCodeList = [];
      let typeOrder = { open: [], delivered: [], cancelled: [] };
      res.map((e) => {
        let subTotal = 0;
        if (e.subOrders) {
          e.subOrders.map((sub) => {
            subTotal += sub.total;
            if (!sellerCodeList.includes(sub.sellerCode)) {
              sellerCodeList.push(sub.sellerCode);
            }
          });
        }
        e.subTotal = subTotal;
        if (e.status === "DELIVERED" || e.status === "PAYMENT_RECEIVED") {
          typeOrder.delivered.push(e);
        } else if (e.status === "CANCELED") {
          typeOrder.cancelled.push(e);
        } else {
          typeOrder.open.push(e);
        }
      });
      let codes = sellerCodeList.join();
      dispatch(getBrandNameByCode(codes, token, res));
      return dispatch(setMyOrders(res, typeOrder));
    })
    .catch((err) => {
      logger(
        "error",
        "Error from getOrders api :" +
          url +
          " : buyerId => " +
          buyerId +
          ": error =>" +
          err.statusText,
        process.env.NEXT_PUBLIC_LOGGER_URL
      );
      apiError("getOrders", err.statusText, "GET", "userProfile");
      if (err.status === 401) {
        Router.push("/signin");
      }
      // console.log(err.message);
      // message.error((err.message || err), 5);
      // setErrors(errors.concat(err));
    });
};

export const setMyOrders = (data, typeOrder) => {
  return {
    type: actionTypes.GET_MY_ORDERS,
    payload: {
      orders: data,
      typeOrder: typeOrder,
    },
  };
};

export const getRfqByStatus = (status, token, buyerId) => async (dispatch) => {
  // dispatch(setScheduleRequests(scheduleRequests))
  let url =
    process.env.NEXT_PUBLIC_REACT_APP_CONTENT_BFF_URL +
    "/home/v1/forms/queries/status?buyer_id=" +
    buyerId +
    "&status=OPEN";

  fetch(
    url,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
        'trace-id' : uuidv4()
      },
    }
  )
    .then((res) => {
      if (res.ok) {
        return res.json();
      } else {
        apiError('getRfqByStatus', res.statusText || "Oops something went wrong. Please try again!", 'GET', 'userProfile');
        throw res;
      }
    })
    .then((res) => {
      let sellerCodeList = [];
      res.map((e) => {
        if (!sellerCodeList.includes(e.sellerId)) {
          sellerCodeList.push(e.sellerId);
        }
      });
      let codes = sellerCodeList.join();
      dispatch(getBrandNameByCode(codes, token, res));
      return dispatch(setQuoteBYStatus(res));
    })
    .catch((err) => {
      logger("error", "Error from getRfqByStatus api :" + url + ' : buyerId =>' +buyerId+ ': error =>' +err.statusText, process.env.NEXT_PUBLIC_LOGGER_URL);
      apiError('getRfqByStatus', err.statusText, 'GET', 'userProfile');
      if(err.status === 401){
        Router.push('/signin');
      }
      // message.error(err.message || err, 5);
    });
};

// Get Collections
export const getCollections =
  (token, buyerId, currency, limit = 10, offset = 0, callback = "") =>
    async (dispatch) => {
        let url = `${process.env.NEXT_PUBLIC_REACT_APP_CONTENT_BFF_URL}/collections/v1/buyer?buyer_id=${buyerId}`;
      let requestBody = {
        currency: currency,
        limit: limit,
        offset: offset,
      }
      fetch(url, {
        method: "POST",
        body: JSON.stringify(requestBody),
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
         'trace-id' : uuidv4() 
        },
      })
        .then((res) => {
          if (res.ok) {
            return res.json();
          } else {
            apiError('getCollections', res.statusText || "ErrorError from getCollections api.", 'GET', 'userProfile');
            throw res;
          }
        })
        .then((res) => {
          if (callback) {
            callback(res);
          }
          return dispatch(setMyCollections(res));
        })
        .catch((err) => {
          logger("error", "Error from getCollections api :" + url + ' : buyerId =>' +buyerId+ ': error =>' +err.statusText, process.env.NEXT_PUBLIC_LOGGER_URL);
          apiError('getCollections', err.statusText, 'GET', 'userProfile');
          if(err.status === 401){
            Router.push('/signin');
          }
          if (callback) {
            callback({ error: "Error" });
          }
        });
    };

export const getAllCollections = (token, buyerId) => async (dispatch) => {
 let url = `${process.env.NEXT_PUBLIC_REACT_APP_CONTENT_BFF_URL}/collections/v1/get-all/buyer`;
  fetch(url, {
    method: "GET",
    headers: {
      Authorization: "Bearer " + token,
      Accept: "*/*",
     'trace-id' : uuidv4() 
    },
  })
    .then((res) => {
      if (res.ok) {
        return res.json();
      } else {
        apiError('getAllCollections', res.statusText || "Error from getAllCollections api.", 'GET', 'userProfile');
        throw res;
      }
    })
    .then((res) => {
      return dispatch(setMyCollections(res));
    })
    .catch((err) => {
      logger("error", "Error from getAllCollections api:" + url + ' : buyerId =>' +buyerId+ ': error =>' +err.statusText, process.env.NEXT_PUBLIC_LOGGER_URL);
      apiError('getAllCollections', err.statusText, 'GET', 'userProfile');
      if(err.status === 401){
        Router.push('/signin');
      }
      console.log("err ", err);
    });
};

export const setMyCollections = (data) => {
  return {
    type: actionTypes.SET_MY_COLLECTION,
    payload: {
      collections: data,
    },
  };
};
;
export const viewThisRfqSuccess = (info) => {
  return {
    type: actionTypes.VIEW_THIS_RFQ_SUCCESS,
    payload: {
      data: info,
    },
  };
};
export const viewThisRfqFailure = (error) => {
  return {
    type: actionTypes.VIEW_THIS_RFQ_FAILURE,
    payload: {
      data: error,
    },
  };
};
// export const getRfqDetails = (token,rfqId, buyerId, callback="") => async (dispatch) => {
//   let url = process.env.NEXT_PUBLIC_REACT_APP_CONTENT_BFF_URL + `/home/forms/v1/queries/${rfqId}`;
 
//   fetch(url, {
//     method: "GET",
//     headers: {
//       'trace-id' : uuidv4()
//     }
   
//   })
//     .then((res) => {
//       if (res.ok) {
//         return res.json();
//       } else {
//         apiError('getRfqDetails', res.statusText || "Error from getRfqDetails api.", 'GET', 'userProfile');
//         throw res;
//       }
//     })
//     .then((res) => {
//      if(callback){
//       callback(res)
//      }
//       return dispatch(viewThisRfqSuccess(res));
//     })
//     .catch((err) => {
//       logger("error", "Error from getRfqDetails api:" + url + ' : buyerId => ' +buyerId+ ' : error => ' +err.statusText, process.env.NEXT_PUBLIC_LOGGER_URL);
//       apiError('getRfqDetails', err.statusText, 'GET', 'userProfile');
//       if(err.status === 401){
//         Router.push('/signin');
//       }
//       console.log("err ", err);
//       dispatch(viewThisRfqFailure(err));
//     });
// };

export const getRfqDetails = (token,rfqId, buyerId, callback="") => async (dispatch) => {
  let url = process.env.NEXT_PUBLIC_REACT_APP_API_FORM_URL + `/forms/v1/queries/${rfqId}`; 
  fetch(url, {
    method: "GET",
   
  })
    .then((res) => {
      if (res.ok) {
        return res.json();
      } else {
        apiError('getRfqDetails', res.statusText || "Error from getRfqDetails api.", 'GET', 'userProfile');
        throw res;
      }
    })
    .then((res) => {
     if(callback){
      callback(res)
     }
      return dispatch(viewThisRfqSuccess(res));
    })
    .catch((err) => {
      logger("error", "Error from getRfqDetails api:" + url + ' : buyerId => ' +buyerId+ ' : error => ' +err.statusText, process.env.NEXT_PUBLIC_LOGGER_URL);
      apiError('getRfqDetails', err.statusText, 'GET', 'userProfile');
      if(err.status === 401){
        Router.push('/signin');
      }
      console.log("err ", err);
      dispatch(viewThisRfqFailure(err));
    });
};

export const setDropShipReserve = (data) => {
  return {
    type: actionTypes.SET_DROPSHIP_RESERVE,
    payload: data
  };
};

export const updateDropShipReserve = (data) => (dispatch) => {
  // store in redux
  if(data){
    return dispatch(setDropShipReserve(data));
  }
}

export const setOffsetMobile = (data) => {
  return {
    type: actionTypes.SET_DROPSHIP_OFFSET,
    payload: {
      dropShipOffset: data * 1,
    },
  };
}

export const dropShipOffset = (input) => (dispatch) => {
  dispatch(setOffsetMobile(input));
}

export const setIsMobile = (data) => {
  return {
    type: actionTypes.SET_DEVICE_TYPE,
    payload: {
      isMobile: data,
    },
  };
};

export const isMobile = (input) => (dispatch) => {
  dispatch(setIsMobile(input));
};
